export default "__VITE_ASSET__C9_WNXzq__"